import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { getApiUrl, getUnprotectedPaths } from "./views/calibrations/shared/services/base.service";
import { MsalInterceptor } from "@azure/msal-angular";

// @Injectable()
// export class PublicInterceptor implements HttpInterceptor {

//     intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
//         console.log("hit public interceptor with", request.url);

//         // If the request URL is in the excluded list, bypass MSAL authentication
//         if (getUnprotectedPaths().some(url => request.url.startsWith(getApiUrl(url)))) {

//             console.log(request.url, "is unprotected");
//             // Modify request to remove Authorization header
//             const anonymousRequest = request.clone({
//                 setHeaders: {
//                     'skipMsal': 'true'
//                     // Authorization: '' // Remove auth token for public endpoints
//                 }
//             });
//             return next.handle(anonymousRequest);
//         }

//         return next.handle(request); // Allow MSAL to handle protected requests
//     }
// }

@Injectable()
export class MSALInterceptorWithExclusions extends MsalInterceptor {
    
    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        // console.log("req -", req.url, "-", getUnprotectedPaths().some(x => req.url.startsWith(getApiUrl(x))) ? 'public path' : 'protected path');

        if(getUnprotectedPaths().some(x => req.url.startsWith(getApiUrl(x))))
            return next.handle(req);

        return super.intercept(req, next);
    }
}
